var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"projects"}},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"mobile"},[_vm._v("Archive")]),_c('project-grid')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }